export default "__VITE_ASSET__vIrXGQHs__"